<input #textFieldInput matInput
       (ngModelChange)="textFieldChanged($event)"
       [id]="textFieldId ? textFieldId : null"
       [attr.placeholder]="placeholderText?placeholderText:null"
       [maxlength]="maxLength"
       [disabled]="(readOnly || ngDisabled || (acInputContainer && acInputContainer.isDisabled))?true:null"
       [attr.autocomplete]="autocomplete"
       [ngModel]="acModel"
       [value]="acModel"
       class="ac-textfield"
       type="text" />
<ng-content></ng-content>
